import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'presto-action-bar-ui',
  styleUrl: 'presto-action-bar-ui.scss',
  shadow: true,
})
export class PrestoActionBarUi {
  @Prop() open?: boolean;

  render() {
    return (
      <div
        class={{
          'bar': true,
          'bar--open': this.open,
        }}
      >
        <span part="content" class="bar__content">
          <slot />
        </span>
        <span part="button" class="bar__button">
          <slot name="button" />
        </span>
      </div>
    );
  }
}
